import React from 'react';
import { Link } from 'react-router-dom';
// import { Nav } from '../../HomePage/Header/Navbar';
import { Footer } from '../Common/Footer';
import { Graph } from '../Common/Graph';
import { SideBar } from '../Common/SideBar';
import seller from '../../Models/seller';
import { Header } from '../Common';
class SellerDashboard extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert('ログインしてください')
            window.location.href = '/login/seller';
        };
        this.state = {
            _id: false,
            collapse: false,
            totalSales: '',
            totalProfits: '',
            NumberOfSales: '',
            activeProducts: '',
            affiliatorCommissions: '',

        };
        this.getInfo()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    getInfo() {
        let x = JSON.parse(localStorage.getItem('info'))
        seller.getSellerInfo(x.id).then(res => {
            this.setState({
                totalSales: parseInt(res.data.total_sale),
                totalProfits: parseInt(res.data.earning),
                NumberOfSales: parseInt(res.data.number_of_pros_sold),
                activeProducts: parseInt(res.data.active_number),
                affiliatorCommissions: parseInt(res.data.total_aff_commission)
            })
        })
    }
    toggle() {
        this.setState({ collapse: !this.state.collapse });
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <SideBar />
                            </div> */}
                            <div className="col-md-12">
                                <div className="mt-5 input_name big_font text-left" style={{ width: '100%',fontSize:'20px' }} >
                                    販売者ダッシュボード
                                    </div>
                                <div className="row">
                                    <Link to={'/service-list'} className="col-md-6" style={{ textDecoration: 'none', color: '#888', marginBottom: '17px' }}>
                                        <div className="summary text-center" style={{ borderRadius: '5px' }}>
                                            <div>販売中商品数</div>
                                            <div>{this.state.activeProducts}</div>
                                        </div>
                                    </Link>
                                    <Link to={'/sales'} style={{ textDecoration: 'none', color: '#888' }} className="col-md-6">
                                        <div className="summary text-center" style={{ borderRadius: '5px' }} data-tip data-for='sadace'>
                                            <div>売れた商品数</div>
                                            <div>{this.state.NumberOfSales} </div>
                                        </div>
                                    </Link>

                                </div>
                                <div className="row mt-3">
                                    <Link to={'/sales'} className="col-md-4" style={{ textDecoration: 'none', color: '#888', marginBottom: '17px' }}>
                                        <div className="summary text-center" style={{ borderRadius: '5px' }}>
                                            <div>販売価格</div>
                                            <div>{this.state.totalSales} 円</div>
                                        </div>
                                    </Link>
                                    <Link to={'/sales'} className="col-md-4" style={{ textDecoration: 'none', color: '#888', marginBottom: '17px' }}>
                                        <div className="summary text-center" style={{ borderRadius: '5px' }}>
                                            <div>売上</div>
                                            <div>{this.state.totalProfits} 円</div>
                                        </div>
                                    </Link>
                                    <div className="col-md-4">
                                        <Link to={'/sales'} style={{ textDecoration: 'none', color: '#888' }}>
                                            <div className="summary text-center" style={{ borderRadius: '5px' }}>
                                                <div>アフィリエイト支払い</div>
                                                <div>{this.state.affiliatorCommissions} 円</div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        } else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-3 input_name big_font guide_text" style={{ width: '100%' }} >
                                            販売者ダッシュボード
                                    </div>
                                        <div className="row">
                                            <Link to={'/service-list'} className="col-md-6" style={{ textDecoration: 'none', color: '#888' }}>
                                                <div className="summary text-center" style={{ borderRadius: '5px', boxShadow: '1px 1px #bfbfbf' }}>
                                                    <div>販売中商品数</div>
                                                    <div>{this.state.activeProducts}</div>
                                                </div>
                                            </Link>
                                            <Link to={'/sales'} style={{ textDecoration: 'none', color: '#888' }} className="col-md-6">
                                                <div className="summary text-center" style={{ borderRadius: '5px', boxShadow: '1px 1px #bfbfbf'  }} data-tip data-for='sadace'>
                                                    <div>売れた商品数</div>
                                                    <div>{this.state.NumberOfSales} </div>
                                                </div>
                                            </Link>

                                        </div>
                                        <div className="row mt-3">
                                            <Link to={'/sales'} className="col-md-4" style={{ textDecoration: 'none', color: '#888' }}>
                                                <div className="summary text-center" style={{ borderRadius: '5px', boxShadow: '1px 1px #bfbfbf'  }}>
                                                    <div>販売価格</div>
                                                    <div>{this.state.totalSales} 円</div>
                                                </div>
                                            </Link>
                                            <Link to={'/sales'} className="col-md-4" style={{ textDecoration: 'none', color: '#888' }}>
                                                <div className="summary text-center" style={{ borderRadius: '5px', boxShadow: '1px 1px #bfbfbf'  }}>
                                                    <div>売上</div>
                                                    <div>{this.state.totalProfits} 円</div>
                                                </div>
                                            </Link>
                                            <div className="col-md-4">
                                                <Link to={'/sales'} style={{ textDecoration: 'none', color: '#888' }}>
                                                    <div className="summary text-center" style={{ borderRadius: '5px', boxShadow: '1px 1px #bfbfbf'  }}>
                                                        <div>アフィリエイト支払い</div>
                                                        <div>{this.state.affiliatorCommissions} 円</div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                        {/* <div className="">
                                        <div className="col-md-12">
                                            <div className="stat_table">
                                                <div className='row'>
                                                    <Link to={'sales'}>
                                                        <td className="stat_numbers" style={{ width: '110px' }}>販売価格<br /><b>{this.state.totalSales}  円</b></td>
                                                    </Link>
                                                    <Link to={'sales'}>
                                                        <td className="stat_numbers alt_colors" style={{ width: '120px' }}>売上<br /><b>{this.state.totalProfits}  円</b></td>
                                                    </Link>
                                                    <Link to={'sales'}>

                                                        <td className="stat_numbers alt_colors2" style={{ width: '110px' }}>売れた商品数<br /><b>{this.state.NumberOfSales}  </b></td>
                                                    </Link>

                                                    <Link to={'/service-list'}>
                                                        <td className="stat_numbers alt_colors3" style={{ width: '110px' }}>販売中商品数<br /><b>{this.state.activeProducts}  </b></td>
                                                    </Link>
                                                    <Link to={'sales'}>
                                                        <td className="stat_numbers alt_colors4" style={{ width: '160px' }}>アフィリエイト支払い<br /><b>{this.state.affiliatorCommissions}  円</b></td>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div> */}
                                        {/* <div>
                                        <Graph />
                                    </div> */}
                                        {/* <div className="bottom_div">
                                        <div className="dash_back">
                                            <div className="custom_padding_dash">
                                                <table className="stat_table">
                                                    <tbody>
                                                        <tr>
                                                            <td className="stat_numbers" style={{ width: '120px' }}>売上<br /><b>{this.state.totalSales}</b></td>


                                                            <td className="stat_numbers alt_colors" style={{ width: '120px' }}>利益<br /><b>{this.state.totalProfits}</b></td>


                                                            <td className="stat_numbers alt_colors2" style={{ width: '100px' }}>売れた商品数<br /><b>{this.state.NumberOfSales}</b></td>


                                                            <td className="stat_numbers alt_colors3" style={{ width: '100px' }}>販売中商品数<br /><b>{this.state.activeProducts}</b></td>


                                                            <td className="stat_numbers alt_colors4">アフィリエイト支払い<br /><b>{this.state.affiliatorCommissions}</b></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { SellerDashboard }